const Loader = ({ isMobileCenter }) => {
    return (
        <div className={`loader ${isMobileCenter ? 'self-center' : ''}`}></div>
    )
}

export default Loader;